module.exports = __webpack_public_path__ + "img/SK31351026.b4e8c6ed.png";